/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Username_Continue_ActionInputs */

const en_onboarding_v1_username_continue_action = /** @type {(inputs: Onboarding_V1_Username_Continue_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue with this username`)
};

const de_onboarding_v1_username_continue_action = /** @type {(inputs: Onboarding_V1_Username_Continue_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit diesem Benutzernamen fortfahren`)
};

const pt_br2_onboarding_v1_username_continue_action = /** @type {(inputs: Onboarding_V1_Username_Continue_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar com este nome de usuário`)
};

const tr_onboarding_v1_username_continue_action = /** @type {(inputs: Onboarding_V1_Username_Continue_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu kullanıcı adıyla devam et`)
};

const zh_cn2_onboarding_v1_username_continue_action = /** @type {(inputs: Onboarding_V1_Username_Continue_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用此用户名继续`)
};

const zh_hk2_onboarding_v1_username_continue_action = /** @type {(inputs: Onboarding_V1_Username_Continue_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用此用戶名稱繼續`)
};

const ko_kr2_onboarding_v1_username_continue_action = /** @type {(inputs: Onboarding_V1_Username_Continue_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 사용자 이름으로 계속`)
};

const ru_ru2_onboarding_v1_username_continue_action = /** @type {(inputs: Onboarding_V1_Username_Continue_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продолжить с этим именем пользователя`)
};

const es_419_onboarding_v1_username_continue_action = /** @type {(inputs: Onboarding_V1_Username_Continue_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar con este nombre de usuario`)
};

/**
* | output |
* | --- |
* | "Continue with this username" |
*
* @param {Onboarding_V1_Username_Continue_ActionInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_username_continue_action = /** @type {((inputs?: Onboarding_V1_Username_Continue_ActionInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Username_Continue_ActionInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_username_continue_action(inputs)
	if (locale === "de") return de_onboarding_v1_username_continue_action(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_username_continue_action(inputs)
	if (locale === "tr") return tr_onboarding_v1_username_continue_action(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_username_continue_action(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_username_continue_action(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_username_continue_action(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_username_continue_action(inputs)
	return es_419_onboarding_v1_username_continue_action(inputs)
});